import { TranslateService } from '@ngx-translate/core';
import { NotificationService, TypeMessage } from 'src/core/services/notification.service';
import { ControlPanelService } from './../../states/control-panel.service';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoaderService } from '../layouts/loader/loader.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private router: Router,
              private notificationService: NotificationService,
              private controlPanelService: ControlPanelService,
              private translateService: TranslateService,
              private loaderService: LoaderService
  ) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      return next.handle(req).pipe(
          catchError( (error) => {
            // console.log("ERROR", error);
            switch (error.status) {
              case 400:
                // Params error
                if (req.url.endsWith('api/authentication/token') || 
                req.url.endsWith('api/authentication/token-pp') || 
                req.url.endsWith('api/authentication/azure-msal') ||
                req.url.endsWith('api/authentication/token-with-code')) {
                  this.translateService.get('Auth.ParamsError').subscribe( e => this.notificationService.displayMessage(TypeMessage.error, e + error.message));
                }
                break;

              case 401:
                // Not authenticated => navigate to login form
                if (req.url.endsWith('api/authentication/token') || 
                    req.url.endsWith('api/authentication/token-pp')) {
                  this.translateService.get('Auth.Error').subscribe( e => this.notificationService.displayMessage(TypeMessage.error, e));
                } else if(req.url.endsWith('api/authentication/azure-msal')) {
                  this.translateService.get('Auth.ErrorAzure').subscribe( e => this.notificationService.displayMessage(TypeMessage.error, e));
                } else if(req.url.endsWith('api/authentication/token-with-code')) {
                  this.translateService.get('Auth.ErrorCode').subscribe( e => this.notificationService.displayMessage(TypeMessage.error, e));
                }
                else {
                  this.translateService.get('Auth.NotConnected').subscribe( e => this.notificationService.displayMessage(TypeMessage.error, e));
                }
                this.loaderService.FinishLoad();
                this.controlPanelService.logout();
                break;

              case 403:
                if (req.url.endsWith('api/authentication/token') || 
                    req.url.endsWith('api/authentication/token-pp') || 
                    req.url.endsWith('api/authentication/azure-msal') ||
                    req.url.endsWith('api/authentication/token-with-code')) {
                  this.notificationService.displayMessage(TypeMessage.error, error.error);
                } else if (error.error != null) {
                  this.notificationService.displayMessage(TypeMessage.error, error.error);
                } else {
                  // Forbidden => user do not have permission
                  /*this.translateService.get('Auth.NotAuthorized')
                      .subscribe( e => this.notificationService.displayMessage(TypeMessage.error, e));*/
                }
                break;

              case 500:
                // General error => display error
                this.translateService.get('Auth.InternalServerError')
                    .subscribe( e => this.notificationService.displayMessage(TypeMessage.error, e + error.message));
                break;
            }

            return throwError(error);
      })
    );
  }
}
